<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
    {{message}}
</div>
<div mat-dialog-actions>
    <button mat-raised-button  (click)="dialogRef.close(true)" cdkFocusInitial class="mat-primary">Ja</button>
    <button mat-raised-button  (click)="dialogRef.close(false)" class="mat-accent">Nein</button>
</div>
